import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { toast } from 'vue3-toastify';

import receiptModelApi from '~/services/receipt-model-api/receipt-model-api';
import { RefundOrigin } from '~/services/receipt-model-api/receipt-model-api.types';

interface RefundTransfersParams {
  origin: RefundOrigin;
  projectId: string;
  reason: string;
}

const getErrorDetail = (error: any): string | undefined =>
  error?.response?.data?.detail || error?.response?.data?.message;

export default function useRefundTransfers() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: RefundTransfersParams) =>
      receiptModelApi.refundTransfers(params.projectId, params.reason, params.origin),
    onError: (error: any) => {
      const status = error?.response?.status;
      const detail = getErrorDetail(error);

      const errorMessages = {
        403: 'Sem permissão para executar o estorno.',
        404: 'Modelo de recebimento não encontrado para este projeto.',
        409: 'Não há transferências elegíveis ou valor para estornar.',
        412: 'O modelo de recebimento não está elegível para estorno.',
        422: 'Motivo inválido. Informe entre 10 e 255 caracteres.',
      } as const;

      const errorMessage = errorMessages[status as keyof typeof errorMessages]
        || detail
        || 'Erro inesperado ao solicitar estorno.';

      toast.error(errorMessage);
    },
    onSuccess: () => {
      toast.success('Estorno solicitado com sucesso.');
      queryClient.invalidateQueries({ queryKey: ['receipt-model'] });
    },
    retry: false,
  });
}
